const VentureBuilder = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        <h1>Venture Builder</h1>
      </div>
    </div>
  );
};

export default VentureBuilder;